import Home from '@/views/User/Home';

export default [
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "user.login" */ '@/views/User/Login.vue'),
  },
  {
    path: '/polityka-prywatnosci',
    name: 'privacyPolicy',
    component: () => import(/* webpackChunkName: "user.test" */ '@/views/User/PrivacyPolicy.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "user.register" */ '@/views/User/Register.vue'),
  },
  {
    path: '/zapomniales-hasla',
    name: 'forgotPassword',
    component: () => import(/* webpackChunkName: "user.forgotPassword" */ '@/views/User/ForgotPassword.vue'),
  },
  {
    path: '/nowe-haslo/:token',
    name: 'newPassword',
    component: () => import(/* webpackChunkName: "user.changePassword" */ '@/views/User/SetNewPassword.vue'),
  },
  {
    path: '/konto',
    name: 'account',
    component: () => import(/* webpackChunkName: "user.account,form" */ '@/views/User/Account.vue'),
  },
  {
    path: '/moje-kursy',
    name: 'courses',
    component: () => import(/* webpackChunkName: "user.courses" */ '@/views/User/Courses.vue'),
  },
  {
    path: '/konto/zaproszenia',
    name: 'invitations',
    component: () => import(/* webpackChunkName: "user.account.invites" */ '@/views/User/MyInvitations.vue'),
  },
  {
    path: '/konto/nowe-zaproszenie',
    name: 'newInvitation',
    component: () => import(/* webpackChunkName: "user.account.invites.new" */ '@/views/User/AddInvitationCode.vue'),
  },
];
